import { useState, MouseEvent, FC } from 'react';

import { ClipboardCheck, MessageSquareMore, MessageSquareDot, Trophy } from 'lucide-react';
import { BaseMenuItem, BaseMenu } from 'wbs-components-lib';

import { TelegramChatStatusesEnum } from '@shared/constants';

import { TelegramChatSettingsTableActionsProps } from './types';

export const TelegramChatSettingsTableActions: FC<TelegramChatSettingsTableActionsProps> = ({
  status,
  isChatUnread,
  handleOpenTelegramChatModal,
  handleTakeTelegramChat,
  handleOpenFinishTelegramChatModal,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenActionsMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleClosActionsMenu = () => {
    setMenuAnchor(null);
  };

  const menuItems: BaseMenuItem[] = [
    {
      icon: isChatUnread ? <MessageSquareDot /> : <MessageSquareMore />,
      text: 'Chat',
      onClick: handleOpenTelegramChatModal,
    },
    {
      icon: <ClipboardCheck />,
      isDisabled: status !== TelegramChatStatusesEnum.INITIAL,
      text: 'Take TelegramChat',
      onClick: handleTakeTelegramChat,
    },
    {
      icon: <Trophy />,
      text: 'Finish',
      isDisabled: status !== TelegramChatStatusesEnum.PROCESSED,
      onClick: handleOpenFinishTelegramChatModal,
    },
  ];

  return (
    <BaseMenu
      menuItems={menuItems}
      menuAnchor={menuAnchor}
      isMenuOpened={isMenuOpened}
      handleOpenMenu={handleOpenActionsMenu}
      handleCloseMenu={handleClosActionsMenu}
    />
  );
};
